module.exports = __webpack_public_path__ + "img/excited.3a38253c.png";